export { default } from '../../common/components/UserPageHeader';
